import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import { markControlAsTouched } from '../form-control/form-control.utils';

export const highlightInvalidControls = (
  ...controls: AbstractControl[]
): void => {
  markControlAsTouched(...controls);

  const invalidElement: HTMLElement | null = document.querySelector(
    '.form-control--invalid.form-control--touched',
  );

  invalidElement?.scrollIntoView({
    behavior: 'smooth',
    block: 'center',
  });
  invalidElement?.focus();
};

export function clearFormControls(
  form: UntypedFormGroup | undefined | null,
  ...controlKeys: string[]
): void {
  const formValue: Record<string, null> = controlKeys.reduce(
    (patchValue: Record<string, null>, controlKey: string) => ({
      ...patchValue,
      [controlKey]: null,
    }),
    {},
  );

  form?.patchValue(formValue);
}
